import { toggleChildByName } from "../togglers/toggleChildByName";

export const hideUnnecessaryBolt = ({ activeArray = [], findFn = () => true } = {}) => {
    const addedObj = activeArray.find(findFn);
    if (!addedObj) {
        console.warn(
            `[hideUnnecessaryBolt] Не удалось скрыть нужный болт, т.к. с текущей функцией поиска (findFn) не был найден объект в activeArray`,
        );
    }
    const isOstrov = servObj.redactorModeObject.name.includes("ostrov");

    toggleChildByName("bolt__", !isOstrov, addedObj);
    toggleChildByName("bolt_ostrov", isOstrov, addedObj);
};
